import React from "react";
import { Button, Card } from "react-bootstrap";
import { 
  FaPhone, FaBuilding, FaWallet, 
  FaMapMarkerAlt, FaCalendarCheck, FaChevronRight, FaPhoneAlt, FaWalking,
  FaLocationArrow, FaEnvelope
} from "react-icons/fa";

import { useDraggable } from "@dnd-kit/core";

import Display from "../../util/Display";
import withRouter from "../../util/WithRouter";
import { MdDragIndicator } from "react-icons/md";

class KanbanCard extends React.Component {
  constructor(props) {
    super(props);
    this.model = props.model;
  }
  onPreview = (id) => this.props.navigate(`${this.props.match.path}/preview/` + `${id}`);

  render() {
    const { lead, headerColor, columnKey, isOverlay = false } = this.props;
    const theme = headerColor || "#4f46e5";
    const name = Display.FieldValue(lead, "firstname", this.model.fields) || "Client Name";
    const initial = name.charAt(0).toUpperCase();
    const styles = {
      card: {
        border: "1px solid #eef2f6",
        borderRadius: "12px",
        background: "#ffffff",
        boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        marginBottom: "10px",
        overflow: "hidden",
        position: "relative"
      },
      header: {
        background: `linear-gradient(to right, ${theme}10, transparent)`,
        padding: "8px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #f8fafc"
      },
      avatar: {
        width: "26px", 
        height: "26px", 
        borderRadius: "6px",
        background: theme, 
        color: "#fff",
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        fontSize: "11px", 
        fontWeight: "bold", 
        marginRight: "8px"
      },
      statusBadge: {
        fontSize: "8px", 
        fontWeight: "800", 
        padding: "2px 6px",
        borderRadius: "4px", 
        backgroundColor: "#fff", 
        color: theme,
        border: `1px solid ${theme}30`, 
        textTransform: "uppercase"
      },
      gridSection: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "6px 12px",
        padding: "10px 12px"
      },
      label: {
        fontSize: "9px", 
        color: "#94a3b8", 
        fontWeight: "700",
        textTransform: "uppercase", 
        marginBottom: "2px", 
        display: "block"
      },
        value: {
        fontSize: "10.5px",
        color: "#334155",
        fontWeight: "600",
        display: "flex",
        alignItems: "flex-start",
        gap: "4px",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        whiteSpace: "normal",
        lineHeight: "1.3"
      },
      feedbackRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px",
        padding: "0 12px 10px 12px",
      },
      feedbackBox: {
        background: "#f8fafc",
        borderRadius: "6px",
        padding: "5px 8px",
        fontSize: "9.5px",
        color: "#64748b",
        borderLeft: `2px solid #e2e8f0`,
        lineHeight: "1.2",
        height: "32px",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: "2",
        WebkitBoxOrient: "vertical"
      },
      dragHandle: {
        display: "flex",
        alignItems: "center",
        marginRight: "6px",
        cursor: "grab",
        opacity: 0.6,
        transition: "opacity 0.2s ease",
        padding: "2px"
      }
    };
    return (
      <DraggableCard id={lead.id} columnKey={columnKey} headerColor={headerColor} lead={lead}> 
        {({ attributes, listeners }) => (
            <Card 
            className={`lead-card ${isOverlay ? "drag-overlay-card" : ""}`} 
            style={{ 
              ...styles.card,
              '--hover-color': theme,
              transform: isOverlay ? "rotate(3deg)" : "none",
              opacity: isOverlay ? 0.8 : 1
            }} 
            onClick={() => { if(lead?.id) this.onPreview(lead.id) }}
            onMouseOver={(e) => {
              if (!isOverlay) {
                e.currentTarget.style.borderColor = theme;
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
                e.currentTarget.querySelector('.drag-handle').style.opacity = 1;
              }
            }}
            onMouseOut={(e) => {
              if (!isOverlay) {
                e.currentTarget.style.borderColor = "#eef2f6";
                e.currentTarget.style.boxShadow = styles.card.boxShadow;
                e.currentTarget.querySelector('.drag-handle').style.opacity = 0.6;
              }
            }}
          >
            <Card.Body style={{ padding: 0 }}>
              {/* HEADER */}
              <div style={styles.header}>
                <div className="d-flex align-items-center">
                  <div 
                    className="drag-handle" 
                    {...attributes} 
                    {...listeners} 
                    style={styles.dragHandle}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <MdDragIndicator size={16} color="rgba(0, 0, 0, 0.6)" />
                  </div>
                  <div style={styles.avatar}>{initial}</div>
                  <h6 style={{ margin: 0, fontSize: "0.85rem", fontWeight: "800", color: "#1e293b" }}>
                    {name}
                  </h6>
                </div>
                <div style={styles.statusBadge}>
                  {Display.FieldValue(this.props.lead, "progress", this.model.fields) || ""}
                </div>
              </div>

              {/* CORE INFO GRID */}
              <div style={styles.gridSection}>
                <div>
                  <span style={styles.label}>{this.model?.fields?.project?.label_name} & {this.model?.fields?.area?.label_name}</span>
                  <div style={styles.value}>
                    <FaBuilding size={8} color={theme}/> 
                    {Display.FieldValue(lead, "project", this.model.fields) || ""} <FaLocationArrow size={8} color={theme}/>{Display.FieldValue(lead, "area", this.model.fields) || ""}
                  </div>
                </div>
                <div>
                  <span style={styles.label}>{this.model?.fields?.min_budget?.label_name} & {this.model?.fields?.max_budget?.label_name}</span>
                  <div style={styles.value}>
                    <FaWallet size={8} color={theme}/> 
                    {Display.FieldValue(lead, "min_budget", this.model.fields) || ""} - {Display.FieldValue(lead, "max_budget", this.model.fields) || ""}
                  </div>
                </div>
                <div>
                  <span style={styles.label}>{this.model?.fields?.phone?.label_name}</span>
                  <div style={styles.value}>
                    <FaPhoneAlt size={8} color={theme}/> 
                    {Display.FieldValue(lead, "phone", this.model.fields) || ""}
                  </div>
                </div>
                <div>
                  <span style={styles.label}>{this.model?.fields?.source?.label_name}</span>
                  <div style={styles.value}>
                    <FaMapMarkerAlt size={8} color={theme}/> 
                    {Display.FieldValue(lead, "source", this.model.fields) || ""}
                  </div>
                </div>
              </div>

              {/* COMPACT FEEDBACK ROW */}
              <div style={styles.feedbackRow}>
                <div>
                  <span style={{...styles.label, color: theme}}>
                    <FaCalendarCheck size={8} style={{marginRight: '3px'}}/> Last Call On {Display.FieldValue(lead, "last_call_date", this.model.fields) || ""}
                  </span>
                  <div style={{...styles.feedbackBox, borderLeftColor: theme}}>
                    {Display.FieldValue(lead, "last_call_feedback", this.model.fields) || ""}
                  </div>
                </div>
                <div>
                  <span style={{...styles.label, color: theme}}>
                    <FaWalking size={8} style={{marginRight: '3px'}}/> Last Visit On {Display.FieldValue(lead, "last_meeting_date", this.model.fields) || ""}
                  </span>
                  <div style={styles.feedbackBox}>
                    {Display.FieldValue(lead, "last_meeting_feedback", this.model.fields) || ""}
                  </div>
                </div>
              </div>
            
            </Card.Body>
          </Card>
        )}  
      </DraggableCard>
    );
  }
}

const DraggableCard = ({ id, columnKey, headerColor, lead, children }) => {
   const {
    attributes,
    listeners,
    setNodeRef,
  } = useDraggable({
    id: `${columnKey}-${id}`,
    data: { columnKey, headerColor, lead },
  });
  
  return (
    <div ref={setNodeRef}>
      {typeof children === "function" 
        ? children({ attributes, listeners })
        : children}
    </div>
  );
}

export default withRouter(KanbanCard);